define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/table/New"
], function (array, declare, lang, New) {

	return declare(New, {
		_canNavigate: function () {
			// summary: disallow Save & Go for Product Issue creation since there may be multiple Issues created
			var issueContainer = this.m_cache.getNode(this.getParent().__Parent__, true);
			var issueContainerType = issueContainer.$Type;
			return issueContainerType != "Material" && issueContainerType != "Style";
		},

		constructor: function (/*Object*/params) {
			// summary: reset parent and attribute to which issue will be added
			var actionNode = this.getParent();
			this.m_urlParent = actionNode.$Type == "IssueLog" ? actionNode.$URL : actionNode.IssueLog;
			this.m_idAttrParent = "Issues";
		},

		getNewNodes: function () {
			// summary: get nodes resulting from action for postprocessing
			if (!this.issues)
				return this.inherited(arguments);
			return this.m_cache.getNodes(this.issues);
		},

		getReturnNodeRequest: function (/*String[]*/urlsNew) {
			// summary: add new url to request
			if (!this.issues)
				return this.inherited(arguments);
			return this.inherited(arguments, [urlsNew.concat(this.issues)]);
		},

		toWriter: function () {
			// summary: create issues according to form and add to the IssueLog
			if (this.popupView._isCreatingMultipleProductIssues()) {
				// S10942: For Product issue, when multiple colors or sizes selected, option to create one Issue per color/size combination

				// default New controller only adds one node - this controller may add many
				this.bUpdateParent = false;
				// validation is handled explicitly
				this.bValidate = false;
				this.issues = this.popupView.toWriterIssues(this);
			} else {
				this.bUpdateParent = true;
				this.issues = null; // clear issues in case they were set earlier
				// validation is handled as usual
				this.bValidate = true;
				return this.inherited(arguments);
			}
		}
	});
});